package org.moxultimate.topwithmox.pages

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.add
import com.varabyte.kobweb.core.data.getValue
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.rememberPageContext
import org.moxultimate.topwithmox.components.layouts.PageLayoutData
import org.moxultimate.topwithmox.navigation.NavParams
import org.moxultimate.topwithmox.shows.data.ShowsResponse
import org.moxultimate.topwithmox.showscrud.update.ShowsUpdatePage

@InitRoute
fun initShowsUpdateRoute(ctx: InitRouteContext) {
    ctx.data.add(PageLayoutData("Edit Show"))

    val urlParams: dynamic = js("new URLSearchParams(window.location.search)")
    fun param(key: String): String = (urlParams.get(key) as? String).orEmpty()

    val showsResponse = ShowsResponse(
        id          = param(NavParams.ID).toLongOrNull() ?: 0L,
        title       = param(NavParams.TITLE),
        type        = param(NavParams.TYPE),
        tags        = param(NavParams.TAGS),
        description = param(NavParams.DESCRIPTION),
        thumbnailPath = param(NavParams.THUMBNAIL_PATH),
        videoLink   = param(NavParams.VIDEO_LINK),
    )
    ctx.data.add(showsResponse)
}

@Page(routeOverride = "showsupdate")
@Layout(".components.layouts.PageLayout")
@Composable
fun ShowsUpdateRoute() {
    val ctx = rememberPageContext()
    val showsResponse = ctx.data.getValue<ShowsResponse>()
    ShowsUpdatePage(show = showsResponse)
}
